module.exports = __webpack_public_path__ + "img/white.af69ae09.png";